import React from 'react';
import Client from 'src/models/Client';
import Card from 'src/components/common/Card.redesign';

interface IGISClientCardProps {
    client: Client;
    key?: string;
    onClick?: () => void;
    selectedClientId?: number;
}

const GISClientCard = (props: IGISClientCardProps) => {
    let address = '';
    if (!props.client.address) {
        address = 'No location provided for client';
    } else {
        address = `${props.client?.address?.city || 'N/A'}, ${props.client?.address?.state?.abbreviation || 'N/A'}`;
        address = address.trim() === 'N/A, N/A' ? '[Address not provided]' : address;
    }
    return (
        <Card 
            onClick={props.onClick} 
            newContext={true} 
            showMenu={true} 
            style={ props.client.id === props.selectedClientId ? { marginTop: '1rem', backgroundColor: 'lightblue'} : { marginTop: '1rem'}}
        >
            <div style={{ padding: '1rem' }}>
                <span style={{ position: 'relative', width: '5.5rem', display: 'inline-block', textAlign: 'right' }}>
                    <span
                        style={{
                            padding: '.2rem .5rem',
                            background: '#6393C1',
                            borderRadius: '.2rem',
                            position: 'relative',
                            fontFamily: 'monospace',
                            marginRight: '.8rem',
                            color: '#FAFAFA',
                            fontWeight: 'bold',
                            width: 'calc(100% - .8rem)',
                            display: 'inline-block',
                        }}
                    >
                        {props.client.clientNumber}
                    </span>
                </span>
                <span className="title">{props.client.cloakName}</span> - {address}
            </div>
        </Card>
    );
};

export default GISClientCard;



// WEBPACK FOOTER //
// ./src/components/gis/portal/GISClientCard.tsx